import { Instance } from '../lib/axiosInterceptor';

const USERS_API_BASE = '/api/v1/users';

const getStoredSession = () => ({
  accessToken: localStorage.getItem('accessToken'),
  refreshToken: localStorage.getItem('refreshToken'),
  email: localStorage.getItem('email'),
  locationId: localStorage.getItem('locationId'),
});

const persistSession = ({ accessToken, refreshToken, email, locationId }) => {
  if (accessToken) localStorage.setItem('accessToken', accessToken);
  if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
  else localStorage.removeItem('refreshToken');
  if (email) localStorage.setItem('email', email);
  if (locationId) localStorage.setItem('locationId', locationId);
  localStorage.removeItem('sessionExpired');
};

const login = async ({ email, password, locationId }) => {
  const response = await Instance.post(`${USERS_API_BASE}/auth/login`, {
    email: email.toLowerCase(),
    password,
    locationId,
  });
  const { accessToken, refreshToken } = response.data.data;
  return { accessToken, refreshToken, email: email.toLowerCase() };
};

const validateSession = async ({ accessToken, refreshToken }) => {
  const response = await Instance.post(`${USERS_API_BASE}/auth/session`, { accessToken, refreshToken });
  return response.data;
};

const checkEmail = async ({ email }) => {
  const response = await Instance.get(`${USERS_API_BASE}/auth/checkEmail/${email}`);
  return response.data;
};

const register = async ({ email, password, confirmPassword, locationId }) => {
  const response = await Instance.post(`${USERS_API_BASE}/auth/register`, {
    email,
    password,
    confirmPassword,
    locationId,
  });
  const { accessToken, refreshToken } = response.data.data;
  return { accessToken, refreshToken, email: email.toLowerCase() };
};

const forgotPassword = async ({ email }) => {
  const response = await Instance.get(`${USERS_API_BASE}/auth/forgotPassword/${email}`);
  return response;
};

const changePassword = async ({ email, otp, password, confirmPassword }) => {
  const response = await Instance.post(`${USERS_API_BASE}/auth/changePassword`, { email, otp, password, confirmPassword });
  return response;
};

const resolveSession = async () => {
  const session = getStoredSession();
  if (!session.accessToken || !session.refreshToken) {
    return { valid: false, reason: 'missing_tokens', session };
  }

  try {
    const data = await validateSession(session);
    const sessionResult = data.data ?? data;

    if (sessionResult.status === 'session-refreshed') {
      persistSession({
        accessToken: sessionResult.accessToken,
        refreshToken: sessionResult.refreshToken,
        email: session.email,
        locationId: session.locationId,
      });
      return {
        valid: true,
        session: {
          ...session,
          accessToken: sessionResult.accessToken,
          refreshToken: sessionResult.refreshToken,
        },
      };
    }

    if (sessionResult.status === 'valid-session') {
      return { valid: true, session };
    }

    localStorage.setItem('sessionExpired', true);
    return { valid: false, reason: 'unknown_status', session };
  } catch (error) {
    localStorage.setItem('sessionExpired', true);
    return { valid: false, reason: 'request_failed', session };
  }
};

export const authService = {
  getStoredSession,
  persistSession,
  login,
  validateSession,
  checkEmail,
  register,
  forgotPassword,
  changePassword,
  resolveSession,
};
